<div class="gov-card">
  <div class="gov-card__header">
    {{ edit ? (customTitles?.cardTitle2 || "Edycja lasu") : (customTitles?.cardTitle || "Dodanie lasu") }}
  </div>
  <div class="gov-card__body">
    <form novalidate autocomplete="off" *ngIf="form as form" [formGroup]="form" (ngSubmit)="submit()">
      @if (form.propertyType) {
        <fieldset>
          <legend>
            Typ nieruchomości
          </legend>
          <div class="row">
            <div class="col-12">
              <div class="row">
                <div class="col-md-5">
                  <p class="mb-3 mt-md-2 mt-sm-3">
                    Cele mieszkaniowe:
                  </p>
                  <div class="form-group" *ngIf='"propertyType" as controlName'>
                    @for (item of form.propertyTypes; track $index) {
                      <div class="custom-radio">
                        <input [name]="controlName"
                               [formControlName]='controlName'
                               [value]="item"
                               type="radio"
                               [id]="controlName + $index">
                        <label [for]="controlName + $index">
                          {{ item }}
                        </label>
                      </div>
                    }
                  </div>
                </div>
                <div class="col-md-5">
                  <p class="mb-3 mt-md-2">
                    Inne cele:
                  </p>
                  <div class="form-group" *ngIf='"propertyType" as controlName'>
                    @for (item of form.otherPurposesPropertyTypes; track $index) {
                      <div class="custom-radio">
                        <input [name]="controlName"
                               [formControlName]='controlName'
                               [value]="item"
                               type="radio"
                               [id]="controlName + 'OtherPurpose' + $index">
                        <label [for]="controlName + 'OtherPurpose' + $index">
                          {{ item }}
                        </label>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      }
      <fieldset>
        <legend>
          Położenie
        </legend>
        <div class="row">
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"city" as controlName'>
              <label [for]='controlName'>
                Miejscowość *
              </label>
              <input
                [id]='controlName'
                [formControlName]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                placeholder='Wpisz tu miejscowość'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"street" as controlName'>
              <label [for]='controlName'>
                Ulica
              </label>
              <input
                [id]='controlName'
                [formControlName]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                placeholder='Wpisz tu nazwę ulicy'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-3'>
            <div class='form-group' *ngIf='"houseNumber" as controlName'>
              <label [for]='controlName'>
                Nr domu
              </label>
              <input
                [id]='controlName'
                [formControlName]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                placeholder='Wpisz tu nr domu'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class="col-12">
            <div class='form-group' *ngIf='"additionalLocationDescription" as controlName'>
              <label [for]='controlName'>
                {{ application() | additionalLocationDescriptionLabel }}
              </label>
              <textarea
                rows="2"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu opis położenia'>
            </textarea>
              <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>
          Identyfikacja
        </legend>
        <div class="row pt-2">
          <div class="col-12">
            <p id="hasLandRegisterDesc" class="pb-3">
              {{ application() | hasLandRegisterLabel }} *
            </p>
            <div class="form-group" *ngIf='"hasLandRegister" as controlName'>
              <div class="custom-radio custom-inline">
                <input aria-labelledby="hasLandRegisterDesc"
                       (change)="form.hasLandRegisterChange(true)"
                       [name]="controlName"
                       [formControlName]='controlName'
                       [value]="true"
                       type="radio"
                       [id]="controlName + 'Tak'">
                <label [for]="controlName + 'Tak'">
                  Tak
                </label>
              </div>
              <div class="custom-radio custom-inline">
                <input aria-labelledby="hasLandRegisterDesc"
                       (change)="form.hasLandRegisterChange(false)"
                       [name]="controlName"
                       [formControlName]='controlName'
                       type="radio"
                       [id]="controlName + 'Nie'"
                       [value]="false">
                <label [for]="controlName + 'Nie'">
                  Nie
                </label>
              </div>
            </div>
          </div>
        </div>
        @if (form.landRegisterNumber) {
          <div class="row">
            <div class='col-md-6'>
              <div class='form-group' *ngIf='"landRegisterNumber" as controlName'>
                <label [for]='controlName'>
                  Numer księgi wieczystej *
                </label>
                <input
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu numer księgi wieczystej'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          </div>
        }
        @if (form.additionalIdentification) {
          <div class="row">
            <div class="col-12">
              <p id="additionalIdentificationDesc" class="pb-3">
                * Dodatkowa identyfikacja:
              </p>
              <div class="form-group" *ngIf='"additionalIdentification" as controlName'>
                <div class="custom-radio custom-inline">
                  <input aria-labelledby="additionalIdentificationDesc"
                         (change)="form.additionalIdentificationChange('Numer zbioru dokumentów')"
                         [name]="controlName"
                         [formControlName]='controlName'
                         value="Numer zbioru dokumentów"
                         type="radio"
                         [id]="controlName + 'NumerZbioruDokumentow'">
                  <label [for]="controlName + 'NumerZbioruDokumentow'">
                    Numer zbioru dokumentów
                  </label>
                </div>
                <div class="custom-radio custom-inline">
                  <input aria-labelledby="additionalIdentificationDesc"
                         (change)="form.additionalIdentificationChange('Numer i data aktu notarialnego')"
                         [name]="controlName"
                         [formControlName]='controlName'
                         value="Numer i data aktu notarialnego"
                         type="radio"
                         [id]="controlName + 'NumerDataAktuNotarialnego'">
                  <label [for]="controlName + 'NumerDataAktuNotarialnego'">
                    Numer i data aktu notarialnego
                  </label>
                </div>
                <div class="custom-radio custom-inline">
                  <input aria-labelledby="additionalIdentificationDesc"
                         (change)="form.additionalIdentificationChange('Numer i data umowy najmu/dzierżawy')"
                         [name]="controlName"
                         [formControlName]='controlName'
                         value="Numer i data umowy najmu/dzierżawy"
                         type="radio"
                         [id]="controlName + 'NumerDataUmowyNajmu'">
                  <label [for]="controlName + 'NumerDataUmowyNajmu'">
                    Numer i data umowy najmu/dzierżawy
                  </label>
                </div>
              </div>
            </div>
          </div>
        }
        @if (form.documentCollectionNumber) {
          <div class="row">
            <div class='col-md-6'>
              <div class='form-group' *ngIf='"documentCollectionNumber" as controlName'>
                <label [for]='controlName'>
                  Numer zbioru dokumentów
                </label>
                <input
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu numer zbioru dokumentów'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          </div>
        }
        @if (form.notarialDeedNumber && form.notarialDeedDate) {
          <div class="row">
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"notarialDeedNumber" as controlName'>
                <label [for]='controlName'>
                  Numer aktu notarialnego
                </label>
                <input
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu numer aktu notarialnego'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"notarialDeedDate" as controlName'>
                <label [for]='controlName'>
                  Data aktu notarialnego
                </label>
                <app-date-picker [id]='controlName' [formControlName]='controlName'>
                </app-date-picker>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          </div>
        }
        @if (form.contractDate && form.contractNumber) {
          <div class="row">
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"contractNumber" as controlName'>
                <label [for]='controlName'>
                  Numer umowy
                </label>
                <input
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu numer umowy'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"contractDate" as controlName'>
                <label [for]='controlName'>
                  Data umowy
                </label>
                <app-date-picker [id]='controlName' [formControlName]='controlName'>
                </app-date-picker>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          </div>
        }
        <div class="row">
          <div class="col-md-6">
            <div class='form-group' *ngIf='"possessionForm" as controlName'>
              <label [for]='controlName'>
                Forma władania *
              </label>
              <select
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'>
                <option value=''>
                  Wybierz
                </option>
                <option value='Własność'>
                  Własność
                </option>
                <option value='Użytkowanie wieczyste'>
                  Użytkowanie wieczyste
                </option>
                <option value='Posiadanie samoistne'>
                  Posiadanie samoistne
                </option>
                <option value='Posiadanie zależne lub posiadanie bez tytułu prawnego'>
                  Posiadanie zależne lub posiadanie bez tytułu prawnego
                </option>
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
        <div class="row">
          @if (form.isPartOfNatureReserve) {
            <div class="col-12">
              <p id="isPartOfNatureReserveDesc" class="pb-3">
                Czy las wchodzi w skład rezerwatów przyrody i parków narodowych? *
              </p>
              <div class="form-group" *ngIf='"isPartOfNatureReserve" as controlName'>
                <div class="custom-radio custom-inline">
                  <input aria-labelledby="isPartOfNatureReserveDesc"
                         [name]="controlName"
                         [formControlName]='controlName'
                         type="radio"
                         [id]="controlName + 'Tak'"
                         [value]="true">
                  <label [for]="controlName + 'Tak'">
                    Tak
                  </label>
                </div>
                <div class="custom-radio custom-inline">
                  <input aria-labelledby="isPartOfNatureReserveDesc"
                         [name]="controlName"
                         [formControlName]='controlName'
                         [value]="false"
                         type="radio"
                         [id]="controlName + 'Nie'">
                  <label [for]="controlName + 'Nie'">
                    Nie
                  </label>
                </div>
              </div>
            </div>
          }
          @if (form.isTaxExempt) {
            <div class="col-md-6">
              <p id="isTaxExemptDesc" class="pb-3">
                Czy las podlega zwolnieniu z podatku? *
              </p>
              <div class="form-group" *ngIf='"isTaxExempt" as controlName'>
                <div class="custom-radio custom-inline">
                  <input aria-labelledby="isTaxExemptDesc"
                         (change)="form.isTaxExemptChange(true)"
                         [name]="controlName"
                         [formControlName]='controlName'
                         type="radio"
                         [id]="controlName + 'Tak'"
                         [value]="true">
                  <label [for]="controlName + 'Tak'">
                    Tak
                  </label>
                </div>
                <div class="custom-radio custom-inline">
                  <input aria-labelledby="isTaxExemptDesc"
                         (change)="form.isTaxExemptChange(false)"
                         [name]="controlName"
                         [formControlName]='controlName'
                         [value]="false"
                         type="radio"
                         [id]="controlName + 'Nie'">
                  <label [for]="controlName + 'Nie'">
                    Nie
                  </label>
                </div>
              </div>
            </div>
          }
          @if (form.taxExemptType) {
            <div class="col-md-6">
              <div class='form-group' *ngIf='"taxExemptType" as controlName'>
                <label [for]='controlName'>
                  Podlega zwolnieniu/uldze *
                </label>
                <select
                  (change)="form.taxExemptTypeChange(form.getElement($event).value)"
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'>
                  <option value=''>
                    Wybierz
                  </option>
                  <option value='Podlega zwolnieniu'>
                    Podlega zwolnieniu
                  </option>
                  <option value='Podlega uldze - Kwotowa'>
                    Podlega uldze - Kwotowa
                  </option>
                  <option value='Podlega uldze - Procentowa'>
                    Podlega uldze - Procentowa
                  </option>
                  <option value='Nie podlega zwolnieniu/uldze'>
                    Nie podlega zwolnieniu/uldze
                  </option>
                </select>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          }
          @if (form.taxExemptionBasis) {
            <div class="col-md-6">
              <div class='form-group' *ngIf='"taxExemptionBasis" as controlName'>
                <label [for]='controlName'>
                  Podstawa zwolnienia z podatku *
                </label>
                <select
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'>
                  <option value=''>
                    Wybierz
                  </option>
                  @for (item of form.taxExemptionBasisList(); track $index) {
                    <option [value]='item.name'>
                      {{ item.name }}
                    </option>
                  }
                </select>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          }
        </div>
        <div class="row">
          @if (form.groundType) {
            <div class="col-md-4">
              <div class='form-group' *ngIf='"groundType" as controlName'>
                <label [for]='controlName'>
                  Typ gruntu *
                </label>
                <select
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'>
                  <option value=''>
                    Wybierz
                  </option>
                  @for (item of form.groundTypes; track $index) {
                    <option [value]='item'>
                      {{ item }}
                    </option>
                  }
                </select>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          }
          @if (form.usageClass) {
            <div class="col-md-4">
              <div class='form-group' *ngIf='"usageClass" as controlName'>
                <label [for]='controlName'>
                  KLasy użytku *
                </label>
                <select
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'>
                  <option value=''>
                    Wybierz
                  </option>
                  @for (item of form.usageClasses; track $index) {
                    <option [value]='item'>
                      {{ item }}
                    </option>
                  }
                </select>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          }
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class='form-group' *ngIf='"districtNumber" as controlName'>
              <label [for]='controlName'>
                Numer obrębu *
              </label>
              <input
                [id]='controlName'
                [formControlName]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                placeholder='Wpisz tu numer obrębu'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class="col-md-4">
            <div class='form-group' *ngIf='"parcelNumber" as controlName'>
              <label [for]='controlName'>
                Numer działki *
              </label>
              <input
                [id]='controlName'
                [formControlName]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                placeholder='Wpisz tu numer działki'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          @if (form.areaHa) {
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"areaHa" as controlName'>
                <label [for]='controlName'>
                  Powierzchnia (ha) *
                </label>
                <input
                  mask='separator.4'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu powierzchnie'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          }
        </div>
      </fieldset>
      @if (form.areaType) {
        <fieldset>
          <legend>
            Powierzchnia
          </legend>
          <div class="row pt-2">
            <div class="col-12">
              <p id="areaTypeDesc" class="pb-3">
                Typ powierzchni: *
              </p>
              <div class="form-group" *ngIf='"areaType" as controlName'>
                <div class="custom-radio custom-inline">
                  <input (change)="form.areaTypeChange('Łączna powierzchnia')"
                         aria-labelledby="areaTypeDesc"
                         [name]="controlName"
                         [formControlName]='controlName'
                         type="radio"
                         [id]="controlName + 'TotalArea'"
                         value="Łączna powierzchnia">
                  <label [for]="controlName + 'TotalArea'">
                    Łączna powierzchnia
                  </label>
                </div>
                <div class="custom-radio custom-inline">
                  <input (change)="form.areaTypeChange('Powierzchnia z podziałem')"
                         aria-labelledby="areaTypeDesc"
                         [name]="controlName"
                         [formControlName]='controlName'
                         value="Powierzchnia z podziałem"
                         type="radio"
                         [id]="controlName + 'WithDivision'">
                  <label [for]="controlName + 'WithDivision'">
                    Powierzchnia z podziałem
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            @if (form.areaM2) {
              <div class='col-md-4'>
                <div class='form-group' *ngIf='"areaM2" as controlName'>
                  <label [for]='controlName'>
                    Łączna powierzchnia użytkowa (m<sup>2</sup>)
                  </label>
                  <input
                    mask='separator.2'
                    decimalMarker=','
                    [dropSpecialCharacters]='false'
                    [id]='controlName'
                    [ngClass]='{ "is-invalid": form.showError(controlName) }'
                    [formControlName]='controlName'
                    placeholder='Wpisz tu powierzchnie'
                    type='text'>
                  <app-validation-errors [control]='form.get(controlName)'>
                  </app-validation-errors>
                </div>
              </div>
            }
            @if (form.areaAbove22m) {
              <div class='col-md-4'>
                <div class='form-group' *ngIf='"areaAbove22m" as controlName'>
                  <label [for]='controlName'>
                    Powierzchnia powyżej <br> wysokości 2,2m (m<sup>2</sup>)
                  </label>
                  <input
                    mask='separator.2'
                    decimalMarker=','
                    [dropSpecialCharacters]='false'
                    [id]='controlName'
                    [ngClass]='{ "is-invalid": form.showError(controlName) }'
                    [formControlName]='controlName'
                    placeholder='Wpisz tu powierzchnie'
                    type='text'>
                  <app-validation-errors [control]='form.get(controlName)'>
                  </app-validation-errors>
                </div>
              </div>
            }
            @if (form.areaAbove22m) {
              <div class='col-md-4'>
                <div class='form-group' *ngIf='"areaAbove22m" as controlName'>
                  <label [for]='controlName'>
                    Powierzchnia pomiędzy <br> wysokością 1,4m a 2,2m (m<sup>2</sup>)
                  </label>
                  <input
                    mask='separator.2'
                    decimalMarker=','
                    [dropSpecialCharacters]='false'
                    [id]='controlName'
                    [ngClass]='{ "is-invalid": form.showError(controlName) }'
                    [formControlName]='controlName'
                    placeholder='Wpisz tu powierzchnie'
                    type='text'>
                  <app-validation-errors [control]='form.get(controlName)'>
                  </app-validation-errors>
                </div>
              </div>
            }
          </div>
        </fieldset>
      }
      <div class="form-actions">
        @if (showCancel) {
          <button type="button" class="btn btn-secondary" (click)="cancel()">
            <i class="fa fa-ban" aria-hidden="true"></i>Anuluj
          </button>
        }
        <button type="submit" class="btn btn-secondary">
          @if (!edit) {
            <i class="fa fa-plus" aria-hidden="true"></i>Dołącz do wniosku
          } @else {
            <i class="fa fa-save"></i>Zaktualizuj dane
          }
        </button>
      </div>
    </form>
  </div>
</div>
